(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CodeEditor", [], factory);
	else if(typeof exports === 'object')
		exports["CodeEditor"] = factory();
	else
		root["CodeEditor"] = factory();
})(window, function() {
return 